module.exports = __webpack_public_path__ + "img/meiyouhongbao.4b005c12.svg";